import type { BaseController } from '@infra/controllers/base.controller';
import type { Tag } from '@entities/tag';
import type { FetchTagsUsecase } from './fetch-tags.usecase';

export type FetchTagsOutput = Tag[];

export class FetchTagsController
  implements BaseController<void, FetchTagsOutput>
{
  constructor(private usecase: FetchTagsUsecase) {}

  async handle(): Promise<FetchTagsOutput> {
    return this.usecase.run();
  }
}
